import React, { useState } from "react";
import { ModalBody } from "reactstrap";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import { useDispatch } from "react-redux";
import {
  postFolderforTeam,
} from "../../../../../redux/team/action";
import LoginLoaderButton from "../../../../Common/Loader/LoginLoaderButton";
import { titlevalidation } from "../../../../Common/commonvalidation";

export default function TeamsAddFolderModel({ teamoverview, setfolderModel }) {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const initialValues = {
    title: "",
  };

  const validationSchema = Yup.object().shape({
    title: titlevalidation,
  });

  const handleSubmit = (values) => {
    setLoading(true);
    const data = {
      ...values,
      type: 5,
      user_id: teamoverview?.company_id,
    };
    dispatch(postFolderforTeam(data));
    setfolderModel((state) => !state);
    setLoading(true);
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      {() => (
        <>
          <a
            onClick={() => setfolderModel((state) => !state)}
            className="btn close-button"
          >
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
              alt=""
            />
          </a>
          <Form>
            <ModalBody>
              <h4>Create A Folder</h4>

              <div className="form-group">
                <label className="label-s">Folder Title</label>
                <Field
                  className="form-control input"
                  type="text"
                  name="title"
                  placeholder="Your title"
                />
                <ErrorMessage name="title" component="div" className="error" />
              </div>
            </ModalBody>
            <div className="modal-footer mt-3">
              <button className="btn " type="submit" disabled={loading}>
                {loading ? <LoginLoaderButton /> : "Save"}
              </button>
            </div>
          </Form>
        </>
      )}
    </Formik>
  );
}
